/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.a-text-input {
  appearance: none;
  display: inline-block;
  padding: 0.4375em;
  border: 1px solid var(--gray-60);
  background: var(--white);
  color: var(--black);
}
.a-text-input:hover, .a-text-input.hover {
  border-color: var(--pacific);
  outline: 1px solid var(--pacific);
}
.a-text-input:focus, .a-text-input.focus {
  border-color: var(--pacific);
  box-shadow: 0 0 0 1px var(--pacific);
  outline: 1px dotted var(--pacific);
  outline-offset: 2px;
}
.a-text-input:disabled, .a-text-input:disabled:hover, .a-text-input:disabled.hover, .a-text-input:disabled:focus, .a-text-input:disabled.focus {
  color: var(--gray-dark);
  background-color: var(--gray-10);
  cursor: not-allowed;
  border-color: var(--gray-60);
  outline: none;
}
.a-text-input--error {
  border-color: var(--red);
  outline: 1px solid var(--red);
}
.a-text-input--error:hover, .a-text-input--error.hover {
  border-color: var(--red-dark);
  outline: 1px solid var(--red-dark);
  outline-offset: 0;
}
.a-text-input--error:focus, .a-text-input--error.focus {
  border-color: var(--red);
  box-shadow: 0 0 0 1px var(--red);
  outline: 1px dotted var(--red);
}
.a-text-input--error:focus:hover, .a-text-input--error:focus.hover, .a-text-input--error.focus:hover, .a-text-input--error.focus.hover {
  border-color: var(--red);
  box-shadow: 0 0 0 1px var(--red);
  outline: 1px dotted var(--red);
  outline-offset: 2px;
}
.a-text-input--warning {
  border-color: var(--gold);
  outline: 1px solid var(--gold);
}
.a-text-input--warning:hover, .a-text-input--warning.hover {
  border-color: var(--gold-dark);
  outline: 1px solid var(--gold-dark);
  outline-offset: 0;
}
.a-text-input--warning:focus, .a-text-input--warning.focus {
  border-color: var(--gold);
  box-shadow: 0 0 0 1px var(--gold);
  outline: 1px dotted var(--gold);
}
.a-text-input--warning:focus:hover, .a-text-input--warning:focus.hover, .a-text-input--warning.focus:hover, .a-text-input--warning.focus.hover {
  border-color: var(--gold);
  box-shadow: 0 0 0 1px var(--gold);
  outline: 1px dotted var(--gold);
  outline-offset: 2px;
}
.a-text-input--success {
  border-color: var(--green);
  outline: 1px solid var(--green);
}
.a-text-input--success:hover, .a-text-input--success.hover {
  border-color: var(--green-dark);
  outline: 1px solid var(--green-dark);
  outline-offset: 0;
}
.a-text-input--success:focus, .a-text-input--success.focus {
  border-color: var(--green);
  box-shadow: 0 0 0 1px var(--green);
  outline: 1px dotted var(--green);
}
.a-text-input--success:focus:hover, .a-text-input--success:focus.hover, .a-text-input--success.focus:hover, .a-text-input--success.focus.hover {
  border-color: var(--green);
  box-shadow: 0 0 0 1px var(--green);
  outline: 1px dotted var(--green);
  outline-offset: 2px;
}

::-webkit-search-decoration {
  appearance: none;
}

::placeholder {
  color: var(--gray-dark);
}

input[type=date]::-webkit-datetime-edit {
  color: var(--gray-dark);
}